
import {createRoot} from "react-dom/client";
import AppRoutes from "./AppRoutes.jsx";
import "./index.css";
import NetworkStatusHandler from "./hooks/useNetworkStatus.js";
import { BrowserRouter } from "react-router-dom";
import "./i18n";
import { CartProvider } from "./context/UserCartContext.jsx";
import {MessageProvider} from "./context/ServiceMessageContext.jsx";
import ErrorBoundary from "./ErrorBoundary.jsx";
import {SideMenuProvider} from "./context/SideMenuContext.jsx";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
    <ErrorBoundary>
        <BrowserRouter>
            <CartProvider>
                <MessageProvider>
                    <SideMenuProvider>
                        <AppRoutes />
                    </SideMenuProvider>
                </MessageProvider>
            </CartProvider>
            <NetworkStatusHandler />
        </BrowserRouter>
    </ErrorBoundary>
);